import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { ShieldAlert } from "lucide-react";

export default function CriticalDevices() {
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    api.get("/emergency/critical-devices").then(({ data }) => setDevices(data));
  }, []);

  return (
    <div className="p-6 lg:p-8">
      <div className="mb-6">
        <div className="bin-label">PRIORITY REGISTRY</div>
        <h1 className="text-3xl font-black tracking-tighter mt-1">Critical Devices</h1>
        <p className="text-sm text-zinc-500 mt-2">Devices pre-approved for guaranteed energy access during emergency mode.</p>
      </div>

      <div className="space-y-3">
        {devices.map((d) => (
          <div key={d.id} className="bin-card p-4 flex items-center gap-4">
            <ShieldAlert className="w-5 h-5 text-cyan-400 shrink-0" />
            <div className="flex-1">
              <div className="font-bold">{d.device_name}</div>
              <div className="text-xs text-zinc-500 font-mono">{d.owner_name} · {d.category}</div>
            </div>
            <div className="text-xs font-mono text-zinc-500">Approved {new Date(d.approved_at).toLocaleDateString()}</div>
          </div>
        ))}
        {devices.length === 0 && (
          <div className="bin-card p-8 text-center text-zinc-500">No critical devices on file.</div>
        )}
      </div>
    </div>
  );
}
